module.exports = __webpack_public_path__ + "res/24-img_play_bg.72a3683493c91512f6512f7caa50c86a.png";